export default __webpack_public_path__ + "assets/footer.57f5e27b.png";